import { ImgHTMLAttributes } from 'react';

export type ILoadingType = 'eager' | 'auto' | 'lazy';

export const handleImgLoading = (
  loading: ILoadingType,
  params: {
    src: string;
    inView: boolean;
    supportsNativeLazyLoading: boolean | undefined;
  },
): Pick<ImgHTMLAttributes<HTMLImageElement>, 'loading' | 'src'> => {
  switch (loading) {
    case 'auto':
      if (params.supportsNativeLazyLoading) {
        return {
          loading: params.inView ? 'eager' : 'lazy',
          src: params.src,
        };
      } else {
        return {
          src: params.inView ? params.src : '',
        };
      }

    case 'lazy':
      if (params.supportsNativeLazyLoading) {
        return {
          loading: 'lazy',
          src: params.src,
        };
      } else {
        return {
          src: params.inView ? params.src : '',
        };
      }

    case 'eager':
    default:
      return {
        loading: 'eager',
        src: params.src,
      };
  }
};
